import AuthorizationPage from './authorization.page';

export default AuthorizationPage;
